import { CaseSensitive, Link } from 'lucide-react';
import { CustomFieldDefinition, CustomFieldType } from '__types__';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createStringFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterStringConfig {
  return {
    label: customFieldDef.name,
    icon:
      customFieldDef.data_type === CustomFieldType.URL ? (
        <Link />
      ) : (
        <CaseSensitive />
      ),
    type: 'string' as const,
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: `Search by ${customFieldDef.name.toLowerCase()}`
    }
  };
}
